<template>
  <div class="tray-buttons fixed">
    <button
      class="btn btn-secondary btn-sm"
      :disabled="disabled"
      @click.prevent="fire('saved')"
    >
      {{ lang.get('buttons.save') }}
    </button>
    <a
      class="action-button"
      :disabled="disabled"
      @click.prevent="fire('canceled')"
    >
      {{ lang.get('buttons.cancel') }}
    </a>
    <a
      v-if="showDeleteButton"
      class="action-button"
      :disabled="disabled"
      @click.prevent="fire('deleted')"
    >
      {{ lang.get('buttons.delete') }}
    </a>
  </div>
</template>

<script>
export default {
  inject: ['lang'],
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    showDeleteButton: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    fire(event) {
      if (!this.disabled) {
        this.$emit(event);
      }
    }
  }
};
</script>
